import instance from '@apis/instance';
import { DiscountResponse } from '@models/discount';

class DiscountApi {
    static getDiscounts(shopId: string): Promise<DiscountResponse> {
        return instance.get('/discounts', { params: { shopId } });
    }
}

export default DiscountApi;
